import * as _ from '@antv/util';
import { DEFAULT_Y } from '../constant';
var Adjust = /** @class */ (function () {
    function Adjust(cfg) {
        var xField = cfg.xField, yField = cfg.yField, _a = cfg.adjustNames, adjustNames = _a === void 0 ? ['x', 'y'] : _a, dimValuesMap = cfg.dimValuesMap;
        this.adjustNames = adjustNames;
        this.xField = xField;
        this.yField = yField;
        this.dimValuesMap = dimValuesMap;
    }
    /**
     * æ¥çç»´åº¦æ¯å¦æ¯ adjust å­æ®µ
     * @param dim
     */
    Adjust.prototype.isAdjust = function (dim) {
        return this.adjustNames.indexOf(dim) >= 0;
    };
    Adjust.prototype.getAdjustRange = function (dim, dimValue, values) {
        var yField = this.yField;
        var index = values.indexOf(dimValue);
        var length = values.length;
        var pre;
        var next;
        // æ²¡æ y å­æ®µï¼ä½æ¯éè¦æ ¹æ® y è°æ´
        if (!yField && this.isAdjust('y')) {
            pre = 0;
            next = 1;
        }
        else if (length > 1) {
            // å¦æä»¥å¶å¼å¤´ï¼ååä¹ï¼å¦ååä»åé¢ä¸ä¸ª
            pre = values[index === 0 ? 0 : index - 1];
            // å¦æä»¥å¶ç»å°¾ï¼ååä¹ï¼å¦ååä»åé¢ä¸ä¸ª
            next = values[index === length - 1 ? length - 1 : index + 1];
            if (index !== 0) {
                pre += (dimValue - pre) / 2;
            }
            else {
                pre -= (next - dimValue) / 2;
            }
            if (index !== length - 1) {
                next -= (next - dimValue) / 2;
            }
            else {
                next += (dimValue - values[length - 2]) / 2;
            }
        }
        else {
            pre = dimValue === 0 ? 0 : dimValue - 0.5;
            next = dimValue === 0 ? 1 : dimValue + 0.5;
        }
        return {
            pre: pre,
            next: next,
        };
    };
    Adjust.prototype.adjustData = function (groupedDataArray, mergedData) {
        var _this = this;
        // ææè°æ´ç»´åº¦çå¼æ°ç»
        var dimValuesMap = this.getDimValues(mergedData);
        // æç§æ¯ä¸ä¸ªåç»æ¥è¿è¡è°æ´
        _.each(groupedDataArray, function (dataArray, index) {
            // éåæææ°æ®éå
            // æ¯ä¸ªåç»ä¸­ï¼åå«æç§ä¸åç dim è¿è¡è°æ´
            _.each(dimValuesMap, function (values, dim) {
                // æ ¹æ®ä¸åçåº¦éåå«è°æ´ä½ç½®
                _this.adjustDim(dim, values, dataArray, index);
            });
        });
    };
    /**
     * å¯¹æ°æ®è¿è¡åç»adjustData
     * @param data æ°æ®
     * @param dim åç»çå­æ®µ
     * @return åç»ç»æ
     */
    Adjust.prototype.groupData = function (data, dim) {
        // è¡¥é½æ°æ®ç©ºæ°æ®ä¸ºé»è®¤å¼
        _.each(data, function (record) {
            if (record[dim] === undefined) {
                record[dim] = DEFAULT_Y;
            }
        });
        // æç§ dim ç»´åº¦åç»
        return _.groupBy(data, dim);
    };
    /** @override */
    Adjust.prototype.adjustDim = function (dim, values, data, index) { };
    /**
     * è·åå¯è°æ´åº¦éå¯¹åºçå¼
     * @param mergedData æ°æ®
     * @return å¼çæ å°
     */
    Adjust.prototype.getDimValues = function (mergedData) {
        var _a = this, xField = _a.xField, yField = _a.yField;
        var dimValuesMap = _.assign({}, this.dimValuesMap);
        // ææçç»´åº¦
        var dims = [];
        if (xField && this.isAdjust('x')) {
            dims.push(xField);
        }
        if (yField && this.isAdjust('y')) {
            dims.push(yField);
        }
        dims.forEach(function (dim) {
            if (dimValuesMap && dimValuesMap[dim]) {
                return;
            }
            // å¨æ¯ä¸ªç»´åº¦ä¸ï¼ææçå¼
            dimValuesMap[dim] = _.valuesOfKey(mergedData, dim).sort(function (v1, v2) { return v1 - v2; });
        });
        // åªæä¸ç»´çæåµä¸ï¼åæ¶è°æ´ yï¼èµäºé»è®¤å¼
        if (!yField && this.isAdjust('y')) {
            var dim = 'y';
            dimValuesMap[dim] = [DEFAULT_Y, 1]; // é»è®¤åå¸å¨ y è½´ç 0 ä¸ 1 ä¹é´
        }
        return dimValuesMap;
    };
    return Adjust;
}());
export default Adjust;
//# sourceMappingURL=adjust.js.map